import DarkMode from "components/header/DarkMode";
import { FAVORITE_URL, MY_REVENUE_URL } from "constant/config";
import { getLogoutUrl, getStationUrl, setClickLogapi } from "helpers";
import React, { useCallback } from "react";
import { Trans } from "react-i18next";

export const UserArea = (props) => {
    const { authenticationReducer } = props;
    const { user_id, note_cnt = 0 } = authenticationReducer;
    const lang = document.documentElement.lang;

    const handleSetClickLog = useCallback((type) => {
        if (type) {
            setClickLogapi("gnb_00000001", { button_type: type });
        }
    }, []);

    return (
        <div
            id="userArea"
            className="user_area"
            onClick={(e) => {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
            }}
        >
            <span className="arrw" />
            <ul className="my_tlist">
                <li>
                    <a
                        href={getStationUrl(user_id)}
                        target="_blank"
                        onClick={() => handleSetClickLog("station")}
                        rel="noopener noreferrer"
                        className="mybs"
                    >
                        <em>
                            <Trans>Blog</Trans>
                        </em>
                    </a>
                </li>
                <li>
                    <a href={FAVORITE_URL} onClick={() => handleSetClickLog("favorite")} className="favorite">
                    <span>
                        <Trans>Yêu thích</Trans>
                    </span>
                    </a>
                </li>
                <li>
                    <a
                        className="my_item"
                        href="https://point.onlive.vn/mygift-quickview"
                        target="_top"
                        onClick={() => handleSetClickLog("item")}
                    >
                        <span>
                            <Trans>Vật phẩm của tôi</Trans>
                        </span>
                    </a>
                </li>
                <li>
                    <a
                        className="my_balloon"
                        href="https://point.onlive.vn/mygift-starballoon"
                        target="_top"
                        onClick={() => handleSetClickLog("balloon")}
                    >
                        <span>
                            <Trans>Bóng bay của tôi</Trans>
                        </span>
                    </a>
                </li>
                <li>
                    <a
                        className="my_gd"
                        href="https://point.onlive.vn/mygift-subscription"
                        onClick={() => handleSetClickLog("subscription")}
                    >
                        <span>
                            <Trans>Đăng ký của Tôi</Trans>
                        </span>
                    </a>
                </li>
                <li>
                    <a
                        className="my_message"
                        href="//note.onlive.vn/app/index.php"
                        target="_top"
                        onClick={() => handleSetClickLog("note")}
                    >
                        <span>
                            <Trans>Thư của tôi</Trans>
                        </span>
                        <span>
                            <Trans note_cnt={note_cnt}>
                                <span className="memo">{{ note_cnt }}</span>
                            </Trans>
                        </span>
                        {note_cnt > 0 && <span className="new">New</span>}
                    </a>
                </li>
                <li>
                    <a
                        className="my_dashboard"
                        href="//dashboard.onlive.vn/index.php"
                        target="_top"
                        onClick={() => handleSetClickLog("dashboard")}
                    >
                                <span>
                                    <Trans>Cài đặt phát sóng thiết bị bên ngoài</Trans>
                                </span>
                    </a>
                </li>
                <li>
                    <a
                        href="https://member.onlive.vn/app/user_info.php"
                        target="_top"
                        onClick={() => handleSetClickLog("my_info")}
                        className="myinfo"
                    >
                    <span>
                        <Trans>Thông tin tài khoản</Trans>
                    </span>
                    </a>
                </li>
                <li>
                    <a
                        className="my_stat"
                        href="//broadstatistic.onlive.vn"
                        target="_top"
                        onClick={() => handleSetClickLog("stat")}
                    >
                        <span>
                            <Trans>Thống kê của tôi</Trans>
                        </span>
                    </a>
                </li>
                <li>
                    <DarkMode />
                </li>
                <li>
                    <a href={getLogoutUrl()} onClick={() => handleSetClickLog("logout")} className="logout">
                    <span>
                        <Trans>Đăng xuất</Trans>
                    </span>
                    </a>
                </li>
            </ul>
        </div>
    );
};
